// src/hooks/useFetchBundles.js
import { useState, useEffect, useCallback } from "react";
import { api } from "../api";

export default function useFetchBundles() {
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const loadBundles = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await api.getBundles();
      setBundles(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadBundles();
  }, [loadBundles]);

  return { bundles, loading, error, refetch: loadBundles };
}
